// extracted by mini-css-extract-plugin
export default {"container":"editIconButton_container__U0ntI","icon":"editIconButton_icon__07Xks","disabled":"editIconButton_disabled__3DXoP"};